import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";

const ChangePassword = () => {
    const navigator = useNavigate();

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [errors, setErrors] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [loading, setLoading] = useState(false);

    const [showPassword, setShowPassword] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors({ ...errors, [name]: "" });

        if (name === "oldPassword") setOldPassword(value);
        if (name === "newPassword") setNewPassword(value);
        if (name === "confirmPassword") setConfirmPassword(value);
    };

    const togglePassword = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let validationErrors = {};

        if (!oldPassword.trim()) {
            validationErrors.oldPassword = "Old password is required";
        }

        if (!newPassword.trim()) {
            validationErrors.newPassword = "New password is required";
        }

        if (!confirmPassword.trim()) {
            validationErrors.confirmPassword = "Confirm Password is required";
        } else if (newPassword !== confirmPassword) {
            validationErrors.confirmPassword = "Passwords don't match";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post("changePassword", {
                oldPassword: oldPassword,
                newPassword: newPassword,
            });

            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/");
            }
        } catch (error) {
            toast.error(
                error?.response?.data?.message ||
                    "Something went wrong. Please try again!!"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="page-header mt-5 mx-4">
                <h3 className="page-title">Change Password</h3>
            </div>
            <div className="col-md-12 grid-margin stretch-card">
                <div className="col-md-9">
                    <div className="card">
                        <div className="card-body">
                            <form className="pt-3" onSubmit={handleSubmit}>
                              <div className="form-group row mb-3">
  <label className="col-sm-3 col-form-label">
    Current Password
  </label>

  <div className="col-sm-9">
    <div className="password-wrapper">
      <input
        type={showPassword.oldPassword ? "text" : "password"}
        className="form-control form-control-sm border border-dark"
        id="oldPassword"
        name="oldPassword"
        placeholder="Enter current password"
        value={oldPassword}
        onChange={handleChange}
      />

      <span
        className="eye-icon"
        onClick={() => togglePassword("oldPassword")}
      >
        <i
          className={`fa ${
            showPassword.oldPassword ? "fa-eye-slash" : "fa-eye"
          }`}
        />
      </span>
    </div>

    {/* ERROR MESSAGE */}
    {errors.oldPassword && (
      <p className="text-danger mt-1">{errors.oldPassword}</p>
    )}
  </div>
</div>


                               <div className="form-group row mb-3">
  <label className="col-sm-3 col-form-label">
    New Password
  </label>

  <div className="col-sm-9">
    <div className="password-wrapper">
      <input
        type={showPassword.newPassword ? "text" : "password"}
        className="form-control form-control-sm border border-dark"
        id="newPassword"
        name="newPassword"
        placeholder="Enter new password"
        value={newPassword}
        onChange={handleChange}
      />

      <span
        className="eye-icon"
        onClick={() => togglePassword("newPassword")}
      >
        <i
          className={`fa ${
            showPassword.newPassword ? "fa-eye-slash" : "fa-eye"
          }`}
        />
      </span>
    </div>

    {errors.newPassword && (
      <p className="text-danger mt-1">{errors.newPassword}</p>
    )}
  </div>
</div>


<div className="form-group row mb-3">
  <label className="col-sm-3 col-form-label">
    Confirm Password
  </label>

  <div className="col-sm-9">
    <div className="password-wrapper">
      <input
        type={showPassword.confirmPassword ? "text" : "password"}
        className="form-control form-control-sm border border-dark"
        id="confirmPassword"
        name="confirmPassword"
        placeholder="Enter confirm password"
        value={confirmPassword}
        onChange={handleChange}
      />

      <span
        className="eye-icon"
        onClick={() => togglePassword("confirmPassword")}
      >
        <i
          className={`fa ${
            showPassword.confirmPassword ? "fa-eye-slash" : "fa-eye"
          }`}
        />
      </span>
    </div>

    {errors.confirmPassword && (
      <p className="text-danger mt-1">{errors.confirmPassword}</p>
    )}
  </div>
</div>


                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-info mr-2"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                                Saving...
                                            </>
                                        ) : (
                                            "Save"
                                        )}
                                    </button>
                                    <Link to="/dashboard" >
                                        <button
                                            type="button"
                                            className="btn btn-danger mr-2"
                                            disabled={loading}
                                        >
                                            Back
                                        </button>
                                    </Link>
                                    
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
